import React from 'react';
import { Avatar, Box,  Button } from '@mui/material';
import MUITypography from '../../Components/MUITypography';
import { vmAddButtonSx, vmPageTitleSx } from '../../Styles/VMStyles';

function TitleWithAddButton({ title, onAddClick ,buttonLabel,isButtonDisplay = true}) {
  return (
    <Box
      display="flex"
      alignItems="center"
      // px={2}
      py={1}
      sx={{ width: '100%',mb:2 }}
    >
      <MUITypography variant="pageTitle" sx={vmPageTitleSx}>
        {title}
      </MUITypography>
      {
        isButtonDisplay
        &&
        <Box sx={{ ml: 'auto',mr:2 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={
            <Avatar
                  alt="Room"
                  src={'/static/add_circle.svg'}
                  sx={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    width:24,
                    height:24,                    
                    cursor: "pointer",
                  }}
                />
          }
          onClick={onAddClick}
          sx={vmAddButtonSx}
        >
          {buttonLabel}
        </Button>
      </Box>
      }
      
    </Box>
  );
}

export default TitleWithAddButton;
